import { ScrollingTextRenderer } from "../renderer/StyleRenderer";
import { calculatePercentage } from "../../helper";

const UiLabelList = ({
  list,
  selectable = false,
  labelSelectHandler,
  selectedSet,
  keyValue = false,
}) => {
  const onClickHandler = (e, value) => {
    e.preventDefault();
    console.log(value);
    labelSelectHandler(value);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "4px",
        width: "100%",
        minHeight: "50px",
        marginTop: "10px",
        flexWrap: "wrap",
      }}
    >
      {keyValue
        ? Object.entries(list).map(([key, value]) => (
            <div
              key={key}
              onClick={(e) => {
                if (selectable) {
                  onClickHandler(e, key);
                }
              }}
              style={{
                padding: "10px",
                backgroundColor: selectable
                  ? selectedSet.has(key)
                    ? "#3498db"
                    : "#e8e8e8"
                  : "#e8e8e8",
                color: selectable
                  ? selectedSet.has(key)
                    ? "white"
                    : "black"
                  : "black",
                height: "40px",
                borderRadius: "5px",
                display: "flex",
                gap: "2px",
                alignItems: "center",
                cursor: selectable ? "pointer" : "default",
                width:
                  value.length > 40
                    ? `${calculatePercentage(value.length, 40)}%`
                    : "fit-content",
              }}
            >
              {value.length > 40 ? (
                <ScrollingTextRenderer
                  value={value}
                  width="100%"
                  threshold={20}
                />
              ) : (
                value
              )}
            </div>
          ))
        : list.map((val, index) => (
            <div
              key={index}
              onClick={(e) => {
                if (selectable) {
                  onClickHandler(e, val);
                }
              }}
              style={{
                padding: "10px",
                backgroundColor: selectable
                  ? selectedSet.has(val)
                    ? "#3498db"
                    : "#e8e8e8"
                  : "#e8e8e8",
                color: selectable
                  ? selectedSet.has(val)
                    ? "white"
                    : "black"
                  : "black",
                height: "40px",
                borderRadius: "5px",
                display: "flex",
                gap: "2px",
                alignItems: "center",
                cursor: selectable ? "pointer" : "default",
                width:
                  val.length > 40
                    ? `${calculatePercentage(val.length, 40)}%`
                    : "fit-content",
              }}
            >
              {val.length > 40 ? (
                <ScrollingTextRenderer
                  value={val}
                  width="100%"
                  threshold={20}
                />
              ) : (
                val
              )}
            </div>
          ))}
    </div>
  );
};

export default UiLabelList;
